// Backend と整合させるための最小限の共有的定義（フロント専用）
// 実行時に依存を増やさないため、型と定数のみを提供

export const INTERVIEW_TYPE = {
  FIRST: 'FIRST',
  SECOND: 'SECOND',
} as const;

export type InterviewType = (typeof INTERVIEW_TYPE)[keyof typeof INTERVIEW_TYPE];

export const INTERVIEW_TYPE_LABEL: Record<InterviewType, '一次面接' | '二次面接'> = {
  FIRST: '一次面接',
  SECOND: '二次面接',
};

export const toInterviewTypeLabel = (
  t?: InterviewType | null
): '一次面接' | '二次面接' | '面接' => {
  if (!t) return '面接';
  return INTERVIEW_TYPE_LABEL[t];
};

export const interviewTypeFromLabel = (label: string): InterviewType => {
  const entry = (Object.entries(INTERVIEW_TYPE_LABEL) as Array<[InterviewType, string]>).find(
    ([, v]) => v === label
  );
  // デフォルトは FIRST とする。必要なら UI 側で必須制御済み
  return entry ? entry[0] : INTERVIEW_TYPE.FIRST;
};

// 受け取った値が 'FIRST' | 'SECOND' | 'InterviewType.FIRST' | 日本語ラベル など様々でも
// 一貫して日本語ラベルに正規化して返す安全な関数
export const safeToInterviewTypeLabel = (value?: unknown): '一次面接' | '二次面接' | '面接' => {
  if (typeof value !== 'string') return '面接';
  const token = value.includes('.') ? value.split('.').pop()! : value;
  if (token === INTERVIEW_TYPE.FIRST) return INTERVIEW_TYPE_LABEL.FIRST;
  if (token === INTERVIEW_TYPE.SECOND) return INTERVIEW_TYPE_LABEL.SECOND;
  // もともと日本語ラベルが来るケース
  if (token === INTERVIEW_TYPE_LABEL.FIRST) return INTERVIEW_TYPE_LABEL.FIRST;
  if (token === INTERVIEW_TYPE_LABEL.SECOND) return INTERVIEW_TYPE_LABEL.SECOND;
  return '面接';
};
